/* Modal.css — shared blurred-blue modal primitive. Replicates SignupGate's
   .ccv2-gate-* chrome values exactly (own cc-modal-* class names). SignupGate is
   untouched; this is the go-forward source. */

.cc-modal-overlay {
  position: fixed;
  inset: 0;
  background: var(--cc-scrim, rgba(0, 0, 0, 0.6));
  -webkit-backdrop-filter: blur(6px);
  backdrop-filter: blur(6px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  padding: 1.25rem;
}

.cc-modal-card {
  position: relative;
  width: 100%;
  max-width: 28rem;
  background: var(--cc-card);
  border-radius: 16px;
  box-shadow: 0 32px 100px rgba(0, 28, 70, 0.45), 0 6px 20px rgba(0, 28, 70, 0.2);
  text-align: center;
  overflow: hidden;
}

/* Navy header */
.cc-modal-header {
  background: #002368;
  padding: 28px 28px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}
.cc-modal-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
}
.cc-modal-title {
  margin: 0;
  font-family: var(--cc-font-display, "DM Serif Display", Georgia, serif);
  font-size: 1.25rem;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.92);
  line-height: 1.25;
  letter-spacing: 0.01em;
}

.cc-modal-body {
  padding: 24px 24px 22px;
}
